import PropTypes from 'prop-types';
import React from 'react';
import ReactDOM from 'react-dom';

import * as ModalContainer from 'ui-library/ModalContainer';
import Modal from 'ui-library/modals/Modal';
import * as keyboard from 'util/Keyboard';

const COPY_MODAL_KEY = 'COPY_MODAL_KEY';

interface CopyTextModalProps {
  onRequestClose: () => void;
  onCopy: () => void;
  text: string;
}

export default class CopyTextModal extends React.Component<CopyTextModalProps> {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    onCopy: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
  };

  static close(): void {
    ModalContainer.close(COPY_MODAL_KEY);
  }

  static open(props: CopyTextModalProps): void {
    // eslint-disable-next-line @typescript-eslint/unbound-method -- this is probably spurious but it is failing in CI
    ModalContainer.open(COPY_MODAL_KEY, <CopyTextModal {...props} onRequestClose={CopyTextModal.close} />);
  }

  override componentDidMount(): void {
    const node = ReactDOM.findDOMNode(this.refs.textarea) as HTMLTextAreaElement;
    node.focus();
    node.select();
  }

  override render(): JSX.Element {
    return (
      <Modal
        enableRedesign={false}
        title={`Press ${keyboard.ctrl}-C to copy`}
        onRequestClose={this.props.onRequestClose}
        wrapInForm={false}
        buttons={[
          {
            text: 'Cancel',
            cancel: true,
          },
        ]}
      >
        <textarea
          ref="textarea"
          style={{whiteSpace: 'pre-wrap'}}
          readOnly={true}
          value={this.props.text}
          onCopy={this.props.onCopy}
          rows={5}
        />
      </Modal>
    );
  }
}
